import PropTypes from 'prop-types'

import { FlexColumn } from '../styles/Containers'
import FormInput from '../inputFields/FormInput'
import RichTextEditor from '../inputFields/RichTextEditor'

function CommunicationForm({ disabled = false }) {
  return (
    <FlexColumn gap="10px">
      <FormInput id="name" label="Subject" disabled={disabled} />
      <RichTextEditor disabled={disabled} label="Body" />
    </FlexColumn>
  )
}

CommunicationForm.propTypes = {
  disabled: PropTypes.bool
}

export default CommunicationForm
